import React, { useState } from 'react';
import styled from 'styled-components';

interface Props {
  src?: string;
  initials?: string;
  style?: object;
}

const Avatar = ({ src, initials, style }: Props) => {
  const [url, setUrl] = useState(src);
  return (
    <AvatarDiv style={style}>
      {url ? (
        <img src={url} onError={() => setUrl(undefined)} alt="Avatar" />
      ) : (
        <span>{initials}</span>
      )}
    </AvatarDiv>
  );
};

export default Avatar;

const AvatarDiv = styled.div`
  ${({ theme }) => theme.fonts.FoundersGrotesk};
  min-width: 44px;
  min-height: 44px;
  width: 44px;
  height: 44px;
  background-color: ${({ theme }) => theme.colors.night};
  color: white;
  text-align: center;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  text-transform: uppercase;
  span {
    line-height: 25%;
    position: relative;
    top: 25%;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.largePhonePortrait}) {
    min-width: 34px;
    min-height: 34px;
    width: 34px;
    height: 34px;

    span {
      top: 20%;
    }
  }

  img {
    width: inherit;
    height: inherit;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    object-fit: cover;
  }
`;
